import LogoMark from '../components/LogoMark';
import styles from './MobileAppRedirect.module.css';

// Direct links to the parent app's store listings (not the store homepages).
// Uses the same env-var convention + fallbacks as the super-admin onboarding email.
const IOS_URL = process.env.REACT_APP_PARENT_APP_APPSTORE_LINK || 'https://apps.apple.com/us/app/car-pool/id6762562471';
const ANDROID_URL = process.env.REACT_APP_PARENT_APP_PLAYSTORE_LINK || 'https://play.google.com/store/apps/details?id=com.nativ.carpool';

export default function MobileAppRedirect({ name, onBack }) {
  return (
    <div className={styles.page}>
      <div className={`glass-card ${styles.card}`}>
        <div className={styles.logoRow}>
          <LogoMark size={28} />
          <span className={styles.logoText}>car-pool</span>
        </div>

        <h1 className={styles.heading}>
          {name ? `Hi ${name.split(' ')[0]} —` : 'Welcome —'} the parent experience lives in the app
        </h1>
        <p className={styles.sub}>
          This dashboard is for school staff. As a parent, get the car-pool mobile app to manage pickups,
          message the school, and invite drivers.
        </p>

        <div className={styles.storeRow}>
          <a className={styles.storeBtn} href={IOS_URL} target="_blank" rel="noreferrer">
            <span className={styles.storeIcon}></span>
            <span className={styles.storeText}>
              <span className={styles.storeSmall}>Download on the</span>
              <span className={styles.storeBig}>App Store</span>
            </span>
          </a>
          <a className={styles.storeBtn} href={ANDROID_URL} target="_blank" rel="noreferrer">
            <span className={styles.storeIcon}>▶</span>
            <span className={styles.storeText}>
              <span className={styles.storeSmall}>Get it on</span>
              <span className={styles.storeBig}>Google Play</span>
            </span>
          </a>
        </div>

        <button type="button" className={styles.backLink} onClick={onBack}>
          ← Back to staff sign in
        </button>
      </div>
    </div>
  );
}
